export enum StatusType {
    SUCCESS,
    ERROR,
    UPLOADING,
    ADD_NEW_DIRECTORY_IN_PROGRESS,
    ADD_NEW_DIRECTORY_SUCCESS,
    ADD_NEW_DIRECTORY_ERROR,
    DELETE_FILE_IN_PROGRESS,
    DELETE_FILE_SUCCESS,
    DELETE_FILE_ERROR,

}
